import { Component } from '@angular/core';
import { ViewDealStandardQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/view-deal-standard-quote/view-deal-standard-quote-wrapper.component';

@Component({
  selector: 'app-view-deal-standard-quote-desktop',
  templateUrl: './view-deal-standard-quote-desktop.component.html',
  styleUrls: ['./view-deal-standard-quote-desktop.component.css'],
})
export class ViewDealStandardQuoteDesktopComponent extends ViewDealStandardQuoteWrapperComponent {

}
